// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"ef0938901b4c27a9cce3","293":"c114aca841473b326a33","518":"54a15fb2c8affb07cef2","779":"51550775b2d07828ae7d"}[chunkId] + ".js";
};